
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.6 9.178H9v-2.4a3.6 3.6 0 016.145-2.557c.45.461.774 1.032.936 1.656a1.202 1.202 0 102.328-.6 6.108 6.108 0 00-1.572-2.748A6 6 0 006.6 6.777v2.4a3.6 3.6 0 00-3.6 3.6v8.401a3.6 3.6 0 003.6 3.6h12a3.6 3.6 0 003.601-3.6v-8.4a3.6 3.6 0 00-3.6-3.6zm1.2 12a1.2 1.2 0 01-1.2 1.2h-12a1.2 1.2 0 01-1.2-1.2v-8.4a1.2 1.2 0 011.2-1.2h12a1.2 1.2 0 011.2 1.2v8.4z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.572 14.286c.303-.205.66-.313 1.026-.308a1.789 1.789 0 011.2 3.132v1.668a1.2 1.2 0 11-2.4 0V17.11a1.788 1.788 0 01.175-2.824z","fill":"#FCFC53"}})])
          )
        }
      }
    